<template>
  <template v-if="remaining">
    <div class="flex justify-center bg-vp-secondary-5 rounded text-vp-base-900 text-xl font-bold px-2">
      <p v-if="isExpired">
        {{ $gettext('Time is up!') }}
      </p>
      <p v-else>
        <Accessible :description="$gettext('Time remaining:')" />
        {{ formattedRemaining }}
      </p>
    </div>
  </template>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, onUnmounted } from 'vue';
import { DateTime, Duration } from 'luxon';
import Accessible from '@/components/Accessible.vue';

type Props = {
  targetTime: string;
};
const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'expired'): void;
}>();

const remaining = ref<Duration>();
const interval = ref<number>(0);

onMounted(() => {
  interval.value = setInterval(updateRemaining, 1000);
});

onUnmounted(() => {
  clearInterval(interval.value);
});

const updateRemaining = () => {
  remaining.value = DateTime.now().until(DateTime.fromISO(props.targetTime)).toDuration(['minutes', 'seconds']);

  if (!remaining.value.isValid) {
    remaining.value = Duration.fromMillis(0);
    onExpired();
  }
};

const isExpired = computed(() => remaining?.value?.get('second') == 0);

const onExpired = () => {
  clearInterval(interval.value);
  emit('expired');
};

const formattedRemaining = computed(() => remaining.value.toFormat('m:ss'));
</script>
